import { createReducer, on } from '@ngrx/store';

import { initialPartnerEnterpriseState } from './partner-enterprise.state';
import {
  resetPartnerEnterprise,
  setPartnerEnterprise,
} from './partner-enterprise.actions';

import { Utility } from 'src/services/utility.service';

import { Enterprise } from 'src/models/Enterprise';

export const partnerEnterpriseReducer = createReducer(
  initialPartnerEnterpriseState,

  on(setPartnerEnterprise, (state, action) => {
    const partnerEnterprise: Enterprise = action.partnerEnterprise;
    Utility.setStore('partnerEnterprise', partnerEnterprise, true);

    const latestModificationOnUTC: Date =
      Enterprise.getLatestModificationOnUTCOfEnterprise(partnerEnterprise);
    Utility.setStore(
      'partnerEnterpriseLatestModificationOnUTC',
      latestModificationOnUTC,
      true
    );

    return {
      ...state,
      partnerEnterprise,
      latestModificationOnUTC,
    };
  }),

  on(resetPartnerEnterprise, (state) => {
    Utility.removeStore('partnerEnterprise');
    Utility.removeStore('partnerEnterpriseLatestModificationOnUTC');

    return {
      ...state,
      partnerEnterprise: undefined,
      latestModificationOnUTC: undefined,
    };
  })
);
